export default "__VITE_ASSET__DH3M$Sfb__"